import { useState } from "react";
import { getPayrollAgenticAPI, OrgCategory } from "../../generated/core-api";
import { triggerUrlDownload } from "../../shared";

const api = getPayrollAgenticAPI();

export const useDocumentDownload = (
  orgCategory: OrgCategory,
  orgId: string,
  docId: string,
  filename?: string
) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDocumentClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (isLoading) return;

    try {
      setIsLoading(true);
      const url = await api.getDocumentDownloadUrl(orgCategory, orgId, docId);
      triggerUrlDownload(url, filename);
    } catch (error) {
      console.error("Failed to get download URL:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleDocumentClick,
  };
};
